import OrgNotifEmailListEditor from "./org-notif-email-list-editor";
export { validateOrgNotifEmailListEditor } from './validator';
export default OrgNotifEmailListEditor;